export class KeyTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      ...obj.attributes
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/keys/key.transformer.js